// extracted by mini-css-extract-plugin
export default {"pdf-pages":"pdf-viewer_pdf-pages__iQZb4"};